import ProductReviewsListItem from './ProductReviewsListItem';
import PropTypes from 'prop-types';
import React from 'react';
import '../styles/ProductReviewsList.css';


/**
 * Display a list of reviews.
 * @component
 */
const ProductReviewsList = ({ reviews = [] }) => {
    return <div
        className={'reviews-list--container'}>{(!Array.isArray(reviews) || reviews.length < 1)
            ? <p
                className={'reviews-list--no-content'}>
            There are no reviews for this product yet.
            Be the first to give feedback.
            </p>
            : <>{reviews.map(
                (review, index) => <ProductReviewsListItem
                    key={index}
                    review={review}
                />
            )}</>
        }</div>;
};

/** Prop Types */
ProductReviewsList.propTypes = {
    /** The list of reviews to display. */
    reviews: PropTypes.arrayOf(PropTypes.shape({
        /** The rating given for the review. */
        starsRating: PropTypes.number.isRequired,
        /** The title provided by the customer/user, if any. */
        title: PropTypes.string.isRequired,
        /** The comment provided by the customer/user, if any. */
        comment: PropTypes.string.isRequired,
        /** The customer data, if available. */
        Customer: PropTypes.shape({
            /** The user data associated to the customer. */
            User: PropTypes.shape({
                /** The first name of the user who provided the review. */
                firstName: PropTypes.string,
                /** The last name of the user who provided the review. */
                lastName: PropTypes.string,
            }),
        }),
        /** The date and time the review was submitted. */
        createdAt: PropTypes.string,
    })),
};

export default ProductReviewsList;
